import { render, staticRenderFns } from "./surat_keterangan_njop.vue?vue&type=template&id=03c66b14&"
import script from "./surat_keterangan_njop.vue?vue&type=script&lang=js&"
export * from "./surat_keterangan_njop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports